import { Tag, Text } from "@chakra-ui/react"

type RoundedBadgeProps = {
  text: string
  variant?: "primary" | "secondary" | "error"
  marginRight?: string
}

// Rounded badge component which can be use to show badge inside table component
const RoundedBadge = ({
  text,
  variant = "primary",
  marginRight = "10px",
}: RoundedBadgeProps) => {
  let bg
  if (variant === "error") {
    bg = "#e74c4c"
  } else if (variant === "primary") {
    bg = "#E1E3EC"
  } else {
    bg = "#E1E1E1"
  }
  return (
    <Tag
      bg={bg}
      minH={{ base: "16px", md: "24px" }}
      height={{ base: "16px", md: "24px" }}
      rounded='8px'
      mr={marginRight}
    >
      <Text
        variant={variant === "error" ? "white" : "black"}
        fontSize={{ base: "8px", md: "12px" }}
        fontWeight={400}
        whiteSpace='nowrap'
      >
        {text}
      </Text>
    </Tag>
  )
}

export default RoundedBadge
